module.exports = __webpack_public_path__ + "static/media/icon-medium-referral.7fd36763.svg";